const SERVER = "https://apidev.gestaods.com.br";
export default SERVER;
